module.exports = __webpack_public_path__ + "img/bambelo.3a70efc.jpg";